const languages = [
  { name: "bahasa Indonesia", code: "id", code3: "ind", roman: true }, //Indonesian
  { name: "Cebuano", code: "cb", code3: "ceb", roman: true }, //Cebuano - note cb is not official, but it is what we are using
  { name: "čeština", code: "cs", code3: "ces", roman: true }, //Czech
  { name: "dansk", code: "da", code3: "dan", roman: true }, //Danish
  { name: "Deutsch", code: "de", code3: "deu", roman: true }, //German
  { name: "Eestlane", code: "et", code3: "est", roman: true }, //Estonian
  { name: "English", code: "en", code3: "eng", roman: true }, //English
  { name: "Español", code: "es", code3: "spa", roman: true }, //Spanish
  { name: "Français", code: "fr", code3: "fra", roman: true }, //French
  { name: "Hrvatski", code: "hr", code3: "hrv", roman: true }, //Croatian
  { name: "Italiano", code: "it", code3: "ita", roman: true }, //Italian
  { name: "Latvietis", code: "lv", code3: "lav", roman: true }, //Latvian
  { name: "Lietuvis", code: "lt", code3: "lit", roman: true }, //Lithuanian
  { name: "Magyar", code: "hu", code3: "hun", roman: true }, //Hungarian
  { name: "Malagasy", code: "mg", code3: "mlg", roman: true }, //Malagasy
  { name: "Nederlands", code: "nl", code3: "nld", roman: true }, //Dutch
  { name: "norsk", code: "no", code3: "nor", roman: true }, //Norwegian
  { name: "Polskie", code: "pl", code3: "pol", roman: true }, //Polish
  { name: "Português", code: "pt", code3: "por", roman: true }, //Portuguese
  { name: "Română", code: "ro", code3: "ron", roman: true }, //Romanian
  { name: "Samoa", code: "sm", code3: "smo", roman: true }, //Samoan
  { name: "shqiptar", code: "sq", code3: "sqi", roman: true }, //Albanian
  { name: "Suomalainen", code: "fi", code3: "fin", roman: true }, //Finnish
  { name: "svenska", code: "sv", code3: "swe", roman: true }, //Swedish
  { name: "Tagalog", code: "tl", code3: "tgl", roman: true }, //Tagalog
  { name: "Tiếng Việt", code: "vi", code3: "vie", roman: false }, //Vietnamese
  { name: "Tonga", code: "to", code3: "ton", roman: true }, //Tongan
  { name: "български", code: "bg", code3: "bul", roman: true }, //Bulgarian
  { name: "Монгол", code: "mn", code3: "mon", roman: false }, //Mongolian
  { name: "Pусский", code: "ru", code3: "rus", roman: false }, //Russian
  { name: "Українська", code: "uk", code3: "ukr", roman: false }, //Ukrainian
  { name: "հայերեն", code: "hy", code3: "hye", roman: false }, //Armenian
  { name: "ไทย", code: "th", code3: "tha", roman: false }, //Thai
  { name: "ជនជាតិខ្មែរ។", code: "km", code3: "khm", roman: false }, //Cambodian
  { name: "한국어", code: "ko", code3: "kor", roman: false }, //korean
  { name: "中文", code: "zh", code3: "zho", roman: false }, //chinese(Traditional)
  { name: "日本", code: "ja", code3: "jpn", roman: false }, //japanese
];

const mapNativeNamesOnDataLanguages = (dataLanguages) => {
  const returner = [];
  dataLanguages.forEach((l) => {
    const newLang = { ...l };
    const appMatch = languages.find(
      (l) => l.code3 === newLang.code || l.code === newLang.code
    );
    if (appMatch) {
      newLang.display = appMatch.name;
    } else {
      newLang.display = newLang.name;
    }
    returner.push(newLang);
  });
  return returner;
};
export { mapNativeNamesOnDataLanguages };

export default languages;
